/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import {
  IonListHeader, IonList, IonInput, IonItem, IonContent,
  IonButton, IonRow, IonSelect, IonSelectOption,
} from '@ionic/react'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import 'react-datetime/css/react-datetime.css'
import Datetime from 'react-datetime'
import moment from 'moment'
import { FormTitle, SimpleButton } from '../StyledContainers'
import useJourneyForm from '../../../hooks/journeys/useJourneyForm'
import useJourneyRoutes from '../../../hooks/journeys/useJourneyRoutes'
import EmergencyContactSection from '../../journeys/EmergencyContactSection'
import OvernightDetails from '../../journeys/OvernightDetails'

/**
 *  ==========================
 *    JOURNEY REQUEST FORM
 *  ==========================
 */
const empty = {
  supervisor: '',
  purpose: '',
  leader: '',
  leaderMobile: '',
  vehicleMode: '',
  arrivalTime: '',
  to: '',
  departureTime: '',
  from: '',
  passengers: [],
  routes: [],
}
const emptyEmergency = {
  emergencyPhone: '',
  altEmergencyPhone: '',
}

const emptyAccommodation = {
  driverAccommodation: '',
  driverAccommodationLocation: '',
  driverAccommodationPhone: '',
  passengerAccommodation: '',
  passengerAccommodationLocation: '',
  passengerAccommodationPhone: '',
}

const JourneyForm2 = ({
  routes, drawRoutes, startRoute, onCancel, onSubmit, users,
  defaultValues = empty, defaultEmergency = emptyEmergency, defaultRoutes = [],
  defaultAccommodation = emptyAccommodation, children,
}) => {
  const {
    input,
    setInput,
    emergency,
    setEmergency,
    optionalInput,
    setOptionalInput,
    showOvernight,
    setShowOvernight,
    handlePassengers,
    handleRoutes,
    handleInput,
    handleOptionalInput,
    handleSubmit,
  } = useJourneyForm({
    onSubmit,
    drawRoutes,
    defaultValues,
    defaultEmergency,
    defaultAccommodation,
  })

  useJourneyRoutes(routes, input.routes, (updated) => setInput({ ...input, routes: updated }), drawRoutes)

  /* Obtains the properties attribute of each GeoJSON route object */
  function getFormattedRoutes(routeFeatures) {
    const formattedRoutes = []
    const { length } = Object.keys(routeFeatures)
    for (let i = 0; i < length; i += 1) {
      formattedRoutes.push(routeFeatures[i].properties)
    }
    return formattedRoutes
  }

  const routeFeatures = { ...routes.features }
  const formattedRoutes = getFormattedRoutes(routeFeatures)

  return (
    <>
      <IonContent style={{ height: '85%', '--offset-bottom': '20px' }}>
        <IonList style={{ padding: '10px' }}>
          {
            children
          }
          <IonItem>
            <IonInput id='journey-purpose' onIonChange={handleInput} value={input.purpose} name='purpose' type='text' placeholder='Journey Purpose' />
          </IonItem>
          <IonListHeader>
            <FormTitle>
              <h3 style={{ fontSize: '1rem' }}>Journey Leader</h3>
            </FormTitle>
          </IonListHeader>
          <p style={{ padding: '0 15px' }}>The Journey Leader is in charge of starting and providing updates on the journey during its course.</p>
          <Select
            placeholder='Select Leader'
            name='leader'
            id='select-leader-container'
            className='select-container'
              // eslint-disable-next-line no-undef
            menuPortalTarget={document.body}
            options={users.map((user) => ({ value: user, label: `${user.first_name} ${user.final_name}` }))}
            onChange={(selected) => setInput({ ...input, leader: selected.value })}
          />
          <IonItem>
            <IonInput id='journey-leader-mobile' onIonChange={handleInput} value={input.leaderMobile} name='leaderMobile' type='text' placeholder='Mobile' />
          </IonItem>
          <IonListHeader>
            <FormTitle>
              <h3 style={{ fontSize: '1rem' }}>Mode</h3>
            </FormTitle>
          </IonListHeader>
          <IonItem>
            <IonSelect id='journey-vehicle-mode' onIonChange={handleInput} value={input.vehicleMode} name='vehicleMode' placeholder='Select mode of transport'>
              <IonSelectOption value='Self-drive'>Self-drive</IonSelectOption>
              <IonSelectOption value='Company vehicle'>Company vehicle</IonSelectOption>
              <IonSelectOption value='Private hire / Taxi'>Private hire / Taxi</IonSelectOption>
              <IonSelectOption value='Public transport'>Public transport</IonSelectOption>
              <IonSelectOption value='Other'>Other</IonSelectOption>
            </IonSelect>
          </IonItem>
          <EmergencyContactSection emergency={emergency} setEmergency={setEmergency} />
          <IonListHeader>
            <FormTitle>
              <h3 style={{ fontSize: '1rem' }}>Departure</h3>
            </FormTitle>
          </IonListHeader>
          <IonItem>
            <IonInput id='journey-from-location' onIonChange={handleInput} value={input.from} name='from' type='text' placeholder='Where are you travelling from?' />
          </IonItem>
          <Datetime
            dateFormat='YYYY-MM-DD'
            inputProps={{
              placeholder: 'Departure date/time',
              readOnly: true,
              style: { backgroundColor: 'white' },
            }}
            value={input.departureTime}
            className='journey-departure-time'
            onChange={(e) => setInput({ ...input, departureTime: e })}
            isValidDate={(current) => current.isAfter(moment().subtract(1, 'day'))}
          />
          <IonListHeader>
            <FormTitle>
              <h3 style={{ fontSize: '1rem' }}>Arrival (estimate)</h3>
            </FormTitle>
          </IonListHeader>
          <IonItem>
            <IonInput id='journey-to-location' onIonChange={handleInput} value={input.to} name='to' type='text' placeholder='Where are you travelling to?' />
          </IonItem>
          <Datetime
            dateFormat='YYYY-MM-DD'
            inputProps={{
              placeholder: 'Arrival date/time',
              readOnly: true,
              style: { backgroundColor: 'white' },
            }}
            className='journey-arrival-time'
            value={input.arrivalTime}
            onChange={(e) => setInput({ ...input, arrivalTime: e })}
            isValidDate={(current) => current.isAfter(moment().subtract(1, 'day'))}
          />
          <IonListHeader>
            <FormTitle>
              <h3 style={{ fontSize: '1rem' }}>Route</h3>
            </FormTitle>
          </IonListHeader>
          <Select
            isMulti
            id='select-route-dropdown'
            placeholder='Select Routes'
            className='select-container'
              // eslint-disable-next-line no-undef
            menuPortalTarget={document.body}
            options={formattedRoutes.map((route) => ({ value: route.id, label: route.name }))}
            onChange={handleRoutes}
            value={input.routes}
          />
          <SimpleButton
            onClick={startRoute}
            id='journey-add-new-route'
            style={{ marginTop: '10px', paddingLeft: '15px' }}
          >Add Route +
          </SimpleButton>
          <IonListHeader>
            <FormTitle>
              <h3 style={{ fontSize: '1rem' }}>Passenger Details</h3>
            </FormTitle>
          </IonListHeader>
          <CreatableSelect
            isMulti
            placeholder='Passengers'
            name='colors'
            className='select-container'
            id='journey-passengers'
              // eslint-disable-next-line no-undef
            menuPortalTarget={document.body}
            options={users.map((user) => ({ value: user.email, label: user.email }))}
            value={input.passengers}
            onChange={handlePassengers}
          />
          <OvernightDetails
            showOvernight={showOvernight}
            setShowOvernight={setShowOvernight}
            optionalInput={optionalInput}
            handleOptionalInput={handleOptionalInput}
          />
          <IonListHeader>
            <h2 style={{ fontSize: '1.2rem', marginTop: '10px' }}>Authorised By</h2>
          </IonListHeader>
          <Select
            placeholder='Select user'
            name='supervisor'
            id='select-supervisor-container'
            className='select-container'
              // eslint-disable-next-line no-undef
            menuPortalTarget={document.body}
            options={users.map((user) => ({ value: user, label: user.email }))}
            onChange={(selected) => setInput({ ...input, supervisor: selected.value })}
          />
        </IonList>
      </IonContent>
      <IonRow
        style={{
          height: '15%', alignItems: 'center', backgroundColor: 'white', padding: '0 10px',
        }}
        className='ion-justify-content-end'
      >
        <IonButton style={{ '--background': '#8E151F' }} onClick={onCancel}>Cancel</IonButton>
        <IonButton id='submit-road-journey' style={{ '--background': '#4197A9' }} onClick={handleSubmit}>Submit</IonButton>
      </IonRow>
    </>
  )
}

export default JourneyForm2
